import { Link } from "@mui/material";

interface EmailCellProps {
  email: string | null | undefined;
}

const EmailCell = ({ email }: EmailCellProps) => {
  if (!email) return null;

  return (
    <Link href={`mailto:${email}`} target="_blank" rel="noreferrer">
      {email}
    </Link>
  );
};

export default EmailCell;
